import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ContentWrapperComponent } from '@src/app/shared/components/content-wrapper/content-wrapper.component';
import { HeadingComponent } from '@src/app/shared/components/heading/heading.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

export interface SettingsItem {
  id: string;
  label: string;
  description: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-settings-main',
  standalone: true,
  imports: [
    CommonModule,
    ContentWrapperComponent,
    HeadingComponent,
    ButtonModule,
    CardModule,
  ],
  templateUrl: './main.html',
  styleUrl: './main.scss',
})
export class SettingsMain {
  private readonly router = inject(Router);

  settingsItems: SettingsItem[] = [
    {
      id: 'banner',
      label: 'Banner',
      description: 'Configure a exibição de banners.',
      icon: 'bi bi-image',
      route: '/settings/banner',
    },
    {
      id: 'my-retail',
      label: 'My Retail',
      description: 'Configurações do My Retail.',
      icon: 'bi bi-shop',
      route: '/settings/my-retail',
    },
    {
      id: 'sso',
      label: 'SSO',
      description: 'Configurações de Single Sign-On.',
      icon: 'bi bi-shield-lock',
      route: '/settings/sso',
    },
    {
      id: 'erp',
      label: 'ERP',
      description: 'Configurações de integração ERP.',
      icon: 'bi bi-cloud-arrow-up',
      route: '/settings/erp',
    },
  ];

  navigateTo(item: SettingsItem): void {
    this.router.navigate([item.route]);
  }
}
